
import { Product } from "@/types/product";

export const ipxUC1ULTRA: Product = {
  id: "ipx-uc1-ultra",
  groupId: "avoip",
  name: "IPX-UC1-ULTRA",
  subtitle: "10Gb Box Transceiver",
  description: "The IPX-UC1-ULTRA is a powerful universal controller designed specifically for managing large-scale 10G AV over IP deployments. This advanced control processor features dual 10G network ports and supports up to 500 devices, making it ideal for enterprise-level installations.\n\nEquipped with a high-performance processor, 8GB of RAM, and 128GB SSD storage, the controller provides robust system management capabilities including device auto-discovery, real-time monitoring, and comprehensive backup features. The secure web interface and REST API enable easy integration with third-party control systems.\n\nPerfect for large corporate campuses, universities, and mission-critical installations, the IPX-UC1-ULTRA ensures reliable and efficient management of complex AV over IP systems.",
  features: [
    "Configure as Encoder or Decoder",
    "Zero Frame Latency (1.78ms)",
    "4K60 4:4:4 UHD 120m over 1G CAT 5e",
    "HDMI 2.0b, HDCP 2.2",
    "HDR10, HDR10+, Dolby Vision",
    "LPCM up to 12-channels, Dolby Digital Plus, Dolby TrueHD DTS HD Master Audio & ATMOS",
    "12 bits color depth processing, 16bits OSD",
    "Enterprise Security (AES 256, 802.1x, HTTPS, & SSH)",
    "Scaling, Seamless Switching & Video Wall with Rotation",
    "MJPEG Preview up to 720p30",
    "2.5G LAN PoE+ and 1G SFP for Fiber or 2nd RJ-45",
    "2 HDMI Outputs, 1 HDMI Input",
    "Line In/Out Stereo",
    "RS-232 Serial Port and IR (In/Out)",
    "Channel Mapping with On-Screen Preview",
    "Integrated Web Server for Configuration",
    "USB 2.0 Ports for Cameras, HID Devices, Mass Storage, etc.",
    "AES67 Included",
    "Dante® 2 Ch Audio License Option",
    "Rack and Under Table Mounting",
    "Processor",
    "8 Core 2.4GHz Processor • Android 12 OS",
    "1TB SSD Option",
    "3 USB 3.1",
    "Singal 8K HDMI Outputs or Dual 4K HDMI Outputs", 
    "Options",
    "TeamStream 4K Wireless WiFi Video",
    "ReAX Control Server"
  ],
  specifications: [
    "Processor: Android 12, 8-Core 64-bit ARM Processor 2.4GHz with 6TOP NPU",
    "Memory: 32GB FLASH with 4GB RAM & (Up to 1TB SSD Expansion)",
    "USB Ports: 2 USB 3.1 Type A, 1 Type-C",
    "HDMI Outputs: 2 (HDMI 2.1, HDCP 2.3) Up to 8K60 (Note: Only 1 can be 8K60 while other will be 4K)",
    "Compression: Mimix™ 13:1",
    "Latency: 0 Frame (1.78ms) with Ultra Low Latency Mode",
    "HDMI Inputs: 1 (HDMI 2.0b, HDCP 2.2)",
    "Encryption: AES 256",
    "Audio Analog: Stereo Line In/Out (3.5mm TRS)",
    "1G Ethernet: RJ-45 and SFP",
    "LAN: RJ-45 10/100/1000M PoE",
    "Video Bandwidth: 600MHz (Up to 4K2K 4:4:4 @ 60Hz)",
    "Audio Support: Up to 12 Channels",
    "Video Stream Bandwidth: 10Mbps – 800Mbps (4K60 4:4:4)",
    "USB Bandwidth: 200Mbps (Camera), 160Mbps (HID/Mass Storage Devices)",
    "RS-232: Up to 115k Baud (3.5mm TRS)",
    "IR: Bi-Directional (3.5mm TRS)",
    "USB Connector: 1 USB 2.0 Type C, 2 USB 2.0 Type A",
    "Options: Dante® 2Ch License",
    "Interface: IR or Keyboard via OSD, Web Server",
    "Housing: Black Aluminum Enclosure",
    "Dimensions (L x W x H): 7\" x 7.44\" x 1.094\" (17.7cm x 18.9cm x 2.75cm)",
    "Weight: .453kg [1lbs]",
    "Mounting: Optional: Rack Mount Vertical, Rack Mount Horizontal, Under Table Mount",
    "Power Supply: 48v DC (2 Pin Euro) or PoE+ (LAN)",
    "Power Consumption: 12 Watts, up to 20 Watts with USB",
    "Operation Temperature: 0~40° C [32~104° F]",
    "Storage Temperature: -20~60° C [-4~140° F]",
    "Relative Humidity: 20~90% RH [No Condensation]",
    "Package Contents: 1x VPX-UC1-ULTRA, 2x Mounting Ears"
  ],
  images: [
    "/lovable-uploads/6278ed78-3cd6-4953-9ede-441271cb79a6.png"
  ],
  videoUrl: "https://www.youtube.com/watch?v=example",
  slug: "ipx-uc1-ultra",
  networkSpeed: "10gb"
};
